import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getUsersRolesData } from "Components/Stats/Data/Utilisateurs/Role";
import Margin from "Components/Stats/Margin";
import { useFetchGet } from "Services/api";
import NivoPie from "Components/Stats/Charts/NivoPie";

/**
 * Graphique des utilisateurs par role (étudiants | alumni)
 */
const UsersByRole = (props) => {
  // Répartition des utilisateurs : {étudiants | alumni}

  const [usersByRole, setUsersByRole] = useState([]);

  const usersRolesCount = useFetchGet(
    "/users/stats/count_roles",
    props.auth.token
  );

  const updateUsersRoles = () => {
    setUsersByRole(getUsersRolesData(usersRolesCount.data));
  };

  useEffect(() => {
    if (usersRolesCount.loaded) {
      updateUsersRoles();
    }
  }, [usersRolesCount.loaded]);

  /* Répartition des utilisateurs par role : {étudiants | alumni} */
  return (
    <>
      <NivoPie
        data={usersByRole}
        title={
          "Répartition des utilisateurs par profil sur l'université " +
          props.universityName
        }
        displayPercentage={true}
        colors="pastel2"
      />
      <Margin position="bottom" size="" />
    </>
  );
};

UsersByRole.propTypes = {
  //? Redux states
  users: PropTypes.any,
  auth: PropTypes.any,

  //? Props
  universityName: PropTypes.string,
};

const mapStateToProps = (state) => ({
  users: state.users,
  auth: state.auth,
});

export default connect(mapStateToProps)(UsersByRole);
